import { Component, TemplateRef, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AuthService } from '@app/_services/auth.service';
import { Router } from '@angular/router';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { NzFlexModule } from 'ng-zorro-antd/flex';
import {
  AUTH_ROUTE_PREFIX,
  operations,
  authorityIds,
} from '@app/enums';
import { RequestService } from '@app/_services/request.service';
import { NotificationService } from '@app/_services/_common/notification.service';
import { AboutPopupComponent } from '@app/post-auth/common-components/about-popup/about-popup.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ModalService } from '@app/_services/_common/modal.service';
import { UtilityService } from '@app/_services/utility.service';
import { PermissionService } from '@app/_services/permission.service';
import { ResetPasswordPopupComponent } from '../../../post-auth/common-components/reset-password/reset-password-popup.component';

@Component({
  selector: 'shared-user-menu',
  standalone: true,
  imports: [
    NzIconModule,
    NzDropdownModule,
    NzButtonModule,
    NzMenuModule,
    NzFlexModule,
  ],
  templateUrl: './shared-user-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./shared-user-menu.component.scss'],
})
export class SharedUserMenuComponent {
  @ViewChild('customAboutPopupFooter', { static: true })
  customAboutPopupFooter!: TemplateRef<void>;
  modalRef!: NzModalRef;
  @ViewChild('resetPasswordFooter', { static: false }) resetPasswordFooter!: TemplateRef<void>;
  private router = inject(Router);
  private AS = inject(AuthService);
  loader: boolean = false;

  userName = '';

  constructor(
    private REQ: RequestService,
    private notification: NotificationService,
    private modalService: ModalService,
    private utilityService: UtilityService,
    private permService: PermissionService
  ) {
    const loggedInUser = this.utilityService.getLoggedInUser();

    if (loggedInUser) {
      this.userName = `${loggedInUser.first_name} ${loggedInUser.last_name}`;
    }
  }

  goToUserInfo() {
    this.router.navigate([`app/home/profile`]);
  }

  handleCancel = () => {
    this.modalRef.close();
  };

  logout() {
    this.AS.logout();
    this.router.navigate([`${AUTH_ROUTE_PREFIX}/login`]);
  }

  showModal = () => {
    this.modalRef = this.modalService.aboutPopupModal({
      nzTitle: 'About',
      nzContent: AboutPopupComponent,
      nzFooter: this.customAboutPopupFooter,
    });
  };

  onClickResetPassword = () => {
    this.modalRef = this.modalService.passwordResetModal({
      nzTitle: 'Reset Password',
      nzContent: ResetPasswordPopupComponent,
      nzFooter: this.resetPasswordFooter,
    });
  };

  visibilityStatus(moduleName: string, pageName: string) {
    return this.permService.hasPageAccess(moduleName, pageName);
  }

  handlePasswordReset = () => {
    const component = this.modalRef.getContentComponent() as ResetPasswordPopupComponent;
    const isValid = component.submitForm();
    if (!isValid) {
      return;
    }
    this.submitForm(component.userForm.value);
  };

  submitForm(userForm: any): void {
    this.loader = true;
    const qry = {
      params: {
        password: userForm.oldPassword,
        password2: userForm.newPassword,
        action: 'PASSWORD UPDATE',
      },
      user_data: {
        authority: authorityIds.EDIT_USERS,
        sub_authority: '',
        operation: operations.UPDATE,
        data: {
          action: 'PASSWORD UPDATE',
        },
      },
    };
    this.REQ.post('user/rup', qry).subscribe({
      next: (response) => {
        this.loader = false;
        if (response['code'] === 1) {
          this.notification.error(response.message);
          return;
        }
        this.notification.success(response.message);
        this.handleCancel();
      },
      error: (error) => {
        this.notification.error("There is some error!");
        this.loader = false;
        console.error('signup error:', error);
      },
    });
  }
}
